import React, { useState } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuIcon,
  MenuCommand,
  MenuDivider,
  Button,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

const SortProjects = ({ projectSort, setProjectSort }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleChange = (e) => {
    setProjectSort(e);
  };

  return (
    <div>
      <Menu closeOnSelect={true}>
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          onClick={openMenu}
        >
          Sort projects
        </MenuButton>
        <MenuList minWidth="240px">
          <MenuOptionGroup
            value={projectSort}
            title="Project sort"
            type="radio"
            onChange={handleChange}
          >
            <MenuItemOption value="recent">Recent</MenuItemOption>
            <MenuItemOption value="likes">Likes</MenuItemOption>
            <MenuItemOption value="favorites">Favorites</MenuItemOption>
            <MenuItemOption value="views">Views</MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </div>
  );
};

export default SortProjects;
